module.exports = __webpack_public_path__ + "static/media/portfolio5.0b411206.jpeg";